import { ClientUser, DepartmentMembership, LicenseState, writeAccessLicenseStates } from '@pixacare/domain';
import { isFuture, isPast } from 'date-fns';
import { AdministrationUser } from '../models/administration-user';
import { UserAdminState } from '../models/user-admin-state.enum';

const getUserAdminStateFromMembership = (clientUser: ClientUser, membership: DepartmentMembership): UserAdminState => {
  if (clientUser.licenseState === LicenseState.INVITED) {
    return UserAdminState.INVITED;
  }
  if (!writeAccessLicenseStates.includes(clientUser.licenseState)) {
    return UserAdminState.DISABLED;
  }
  if (!membership?.disabledOn) {
    return UserAdminState.ENABLED;
  }
  if (isFuture(new Date(membership.disabledOn))) {
    return UserAdminState.ENABLED;
  }
  if (isPast(new Date(membership.disabledOn))) {
    return UserAdminState.DISABLED;
  }
};

export const toAdministrationUser = (user: ClientUser, membership: DepartmentMembership): AdministrationUser =>
  ({
    ...user,
    state: getUserAdminStateFromMembership(user, membership),
    isAdmin: membership?.isAdmin,
  }) as AdministrationUser;
